import styled from "styled-components";
import { DARK_GRAY, DINGY_GRAY, WHITE } from "../../../config";

export const Item = styled.div<{ hasItemBackground?: boolean }>`
  background-color: ${({ hasItemBackground }) =>
    hasItemBackground ? `${DINGY_GRAY}` : "transparent"};
  border-radius: 10px;
  padding: 2px 10px;
  margin: 2px 0px;
  margin-right: 12px;
  min-width: 85px;
  min-height: 24px;
  text-align: center;
`;

export const Box = styled.div<{ withoutPadding?: boolean; hasBackground?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  cursor: default;

  font-weight: 400;
  font-size: 14px;
  line-height: 24px;

  background-color: ${({ hasBackground }) => (!hasBackground ? "transparent" : `${DARK_GRAY}`)};
  padding: ${({ withoutPadding }) => (withoutPadding ? "0px" : "10px")};
  border-radius: 4px;
  margin-bottom: 20px;
`;

export const Group = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const Container = styled.div<{ marginBottom?: number }>`
  margin-bottom: ${({ marginBottom }) => (marginBottom ? `${marginBottom}px` : "0px")};
`;

export const Label = styled.h4`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${WHITE};
`;
